import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";

import doctor1 from "../../assets/images/doctors/Dr. Syed Moin Ali.jpg";
import doctor2 from "../../assets/images/doctors/Dr. Lisa Rucker.jpg";
import doctor3 from "../../assets/images/doctors/Dr. Abdul Bari.png";
import doctor4 from "../../assets/images/doctors/Dr. Adil Haider.png";
import doctor5 from "../../assets/images/doctors/Dr. Ahmed Yaqinuddin.jpeg";
import doctor6 from "../../assets/images/doctors/Dr. Ahmet Akin.jpeg";
import doctor7 from "../../assets/images/doctors/Dr. Ahsan Sethi.jpg";
import doctor8 from "../../assets/images/doctors/Dr. Ali.jpg";
import doctor9 from "../../assets/images/doctors/Dr. Eraky.jpeg";
import doctor10 from "../../assets/images/doctors/Dr. Faisal Sultan.jpeg";
import doctor11 from "../../assets/images/doctors/Dr. Manjit Kaur.jpg";
import doctor12 from "../../assets/images/doctors/Dr. Masood Jawaid.jpg";
import doctor13 from "../../assets/images/doctors/Dr. Mahmood Ayaz.jpeg";
import doctor14 from "../../assets/images/doctors/Dr. Muhammad Asif.jpeg";
import doctor15 from "../../assets/images/doctors/Dr. Rehan.jpeg";
import doctor16 from "../../assets/images/doctors/Dr. Renato Paro.jpg";
import doctor17 from "../../assets/images/doctors/Dr. Salman Kirmani.jpg";
import doctor18 from "../../assets/images/doctors/Dr. Vishna.jpg";
import doctor19 from "../../assets/images/doctors/Dr. Waseem Javaid.png";
import doctor20 from "../../assets/images/doctors/Dr. Zaraq Khan.jpeg";
import doctor21 from "../../assets/images/doctors/Mr. Shaukat Jawaid.jpeg";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./homescreen.css";

const HomeScreen = () => {
  // Dynamic window width and player height calculation
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [playerHeight, setPlayerHeight] = useState(
    Math.min(window.innerWidth, 1200) * (9 / 16)
  );

  useEffect(() => {
    const handleResize = () => {
      const newWidth = window.innerWidth;
      setWindowWidth(newWidth);
      // Limit the container width to 1200px max
      const containerWidth = Math.min(newWidth, 1200);
      setPlayerHeight(containerWidth * (9 / 16));
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Doctor slider settings
  const doctorSliderSettings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 600, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };

  // YouTube playlist slider settings (horizontal with arrows)
  const ytSliderSettings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 4 } },
      { breakpoint: 768, settings: { slidesToShow: 3 } },
      { breakpoint: 480, settings: { slidesToShow: 2 } },
      { breakpoint: 320, settings: { slidesToShow: 2 } },
    ],
  };

  // Array of doctor objects
  const doctors = [
    {
      image: doctor9,
      name: "Dr. Mohamed M. Al-Eraky",
      designation:
        "Associate Professor, Head of HPE Dept., Director of MHPE & PhD in HPE programs, Gulf Medical University, UAE.",
    },
    {
      image: doctor1,
      name: "Dr. Syed Moyn Aly",
      designation:
        "Faculty, Department of Educational Development, AKU, Pakistan",
    },
    {
      image: doctor2,
      name: "Dr. Lisa Rucker",
      designation:
        "Professor of Clinical Medicine, Albert Einstein College of Medicine, Bronx, NY",
    },
    {
      image: doctor3,
      name: "Dr. Abdul Bari Khan",
      designation: "President, Indus Hospital & Health Network, Pakistan",
    },
    {
      image: doctor4,
      name: "Dr. Adil Haider",
      designation: "Dean, Medical College, AKU, Pakistan",
    },
    {
      image: doctor5,
      name: "Dr. Ahmed Yaqinuddin",
      designation:
        "Professor of Anatomy & Cell Biology and Vice Dean, Alfaisal University, Saudi Arabia",
    },
    {
      image: doctor6,
      name: "Prof. Dr. Ahmet Akin Sivaslioglu",
      designation: "Professor, Izmir University of Economics, Turkey",
    },
    {
      image: doctor7,
      name: "Dr. Ahsan Sethi",
      designation:
        "Associate Professor & Program Lead, QU Health, Qatar University",
    },
    {
      image: doctor8,
      name: "Dr. Ali Jawaid",
      designation: "Senior Group Leader, Translational Research, Poland",
    },
    {
      image: doctor10,
      name: "Dr. Faisal Sultan",
      designation: "CEO, Shaukat Khanum Memorial Cancer Hospital, Pakistan",
    },
    {
      image: doctor11,
      name: "Dr. Manjit Kaur Khaira",
      designation:
        "Senior Lecturer/Program Coordinator, University of Cyberjaya, Malaysia",
    },
    {
      image: doctor12,
      name: "Dr. Masood Jawaid",
      designation:
        "Director Medical Affairs & eLearning, Pakistan Journal of Medical Sciences",
    },
    {
      image: doctor13,
      name: "Prof. Mahmood Ayyaz",
      designation: "Vice Chancellor, King Edward Medical College, Pakistan",
    },
    {
      image: doctor14,
      name: "Dr. Muhammad Asif",
      designation:
        "Assistant Professor, Microbiology, Government College University, Lahore",
    },
    {
      image: doctor15,
      name: "Prof. Rehan Ahmed Khan",
      designation: "Dean & HOD, Riphah Institute of Assessment, Pakistan",
    },
    {
      image: doctor16,
      name: "Prof. Renato Paro",
      designation:
        "Professor Emeritus, Biosystems Science & Engineering, Switzerland",
    },
    {
      image: doctor17,
      name: "Dr. Salman Kirmani",
      designation:
        "Chair, Division of Women & Child Health, Aga Khan University, Pakistan",
    },
    {
      image: doctor18,
      name: "Vishna Devi V Nadarajah",
      designation: "CEO & Provost, Medical Education, Malaysia",
    },
    {
      image: doctor19,
      name: "Dr. Waseem Javaid",
      designation: "Project Director, SEHAT Medical Complexes, Pakistan",
    },
    {
      image: doctor20,
      name: "Dr. Zaraq Khan",
      designation:
        "Associate Professor, Obstetrics & Gynecology, Mayo Clinic, USA",
    },
    {
      image: doctor21,
      name: "Shaukat Ali Jawaid",
      designation: "Chief Editor, Pulse International & PJMS, Pakistan",
    },
  ];

  // State for YouTube playlist and player
  const [videoList, setVideoList] = useState([]);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const API_KEY = "AIzaSyBpNPLpXPhdQd3LlwvqjKuH4IhvaHdL9iE";
  const PLAYLIST_ID = "PLwp6KO_NS8gtDoSZ6aIKYBimRwKgDJ0yb";

  useEffect(() => {
    const fetchPlaylistVideos = async () => {
      try {
        const response = await fetch(
          `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=50&playlistId=${PLAYLIST_ID}&key=${API_KEY}`
        );
        const data = await response.json();
        if (data.error) {
          throw new Error(data.error.message);
        }
        const videos = data.items.map((item) => {
          const thumbnails = item.snippet.thumbnails;
          const thumbnail =
            (thumbnails && thumbnails.medium && thumbnails.medium.url) ||
            (thumbnails && thumbnails.default && thumbnails.default.url) ||
            "";
          return {
            id: item.snippet.resourceId.videoId,
            title: item.snippet.title,
            thumbnail,
          };
        });
        setVideoList(videos);
        if (videos.length > 0) {
          setSelectedVideo(videos[0].id);
        }
        setLoading(false);
      } catch (err) {
        console.error("Error fetching playlist:", err);
        setError(err.message);
        setLoading(false);
      }
    };

    fetchPlaylistVideos();
  }, [API_KEY, PLAYLIST_ID]);

  const getEmbedUrl = (videoId) =>
    `https://www.youtube.com/embed/${videoId}?autoplay=1`;

  return (
    <div className="home-screen-container">
      <div className="home-screen">
        <div className="home-data-container">
          <h1 className="mobile-date">23-April-2025 to 26-April-2025</h1>
          <div className="main-data">
            {/* Data Lists */}
            <div className="data-lists">
              <h2>Who Should Attend?</h2>
              <ul>
                <li>Basic and Clinical Sciences Faculty</li>
                <li>Nursing Faculty</li>
                <li>Allied Health Faculty</li>
                <li>Medical Educationists</li>
                <li>General Practitioners</li>
                <li>Post-Graduate Residents</li>
                <li>Family Physicians</li>
                <li>Medical and Allied Health Students</li>
              </ul>
              <p>--------------------------------------</p>
              <h2>Last Date for Abstract Submission</h2>
              <h3 className="yellow-date">15th March 2025</h3>
            </div>
            <div className="data-lists">
              <h2>Postgraduate Oral Research Competition</h2>
              <ul>
                <li>First Prize Rs. 100,000/-</li>
                <li>Second Prize Rs. 75,000/-</li>
                <li>Third Prize Rs. 50,000/-</li>
              </ul>
              <h2 className="margin-top">
                Prizes for Undergraduate Oral Research Competition
              </h2>
              <ul>
                <li>First Prize Rs. 30,000/-</li>
                <li>Second Prize Rs. 25,000/-</li>
                <li>Third Prize Rs. 15,000/-</li>
              </ul>
            </div>
            <div className="data-lists">
              <h2>For Correspondence</h2>
              <ul>
                <li>Manager Coordination</li>
                <li>
                  Shalamar Medical &amp; Dental College,
                  <br /> Shalamar Link Road, Lahore.
                </li>
                <li>Tel: +92-42-3685-2660</li>
                <li>Fax: +92-42-3683-5555</li>
                <li>Email: conference@smdc.edu.pk</li>
                <li>
                  <a href="https://conference.smdc.edu.pk">
                    Web: https://conference.smdc.edu.pk
                  </a>
                </li>
              </ul>
              <h2 className="margin-top">Registration Fee</h2>
              <ul>
                <li>There is no registration fee to attend this conference.</li>
              </ul>
            </div>
          </div>
        </div>

        {/* YouTube Playlist & Player Section */}
        <div className="yt-section">
          {loading ? (
            <p>Loading videos...</p>
          ) : error ? (
            <p>Error: {error}</p>
          ) : (
            <>
              <Slider {...ytSliderSettings}>
                {videoList.map((video) => (
                  <div
                    key={video.id}
                    className={`yt-playlist-item ${
                      selectedVideo === video.id ? "active" : ""
                    }`}
                    onClick={() => setSelectedVideo(video.id)}
                  >
                    <img
                      src={video.thumbnail}
                      alt={video.title}
                      className="yt-thumbnail"
                    />
                    <p className="yt-title">{video.title}</p>
                  </div>
                ))}
              </Slider>
              <div className="yt-player">
                {selectedVideo && (
                  <iframe
                    width="100%"
                    height={playerHeight}
                    src={getEmbedUrl(selectedVideo)}
                    title="YouTube Video Player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                )}
              </div>
            </>
          )}
        </div>

        {/* Slider Section for Doctor Images */}
        <div className="slider-container">
          <h2>Our Esteemed Speakers</h2>
          <Slider {...doctorSliderSettings}>
            {doctors.map((doctor, index) => (
              <div key={index} className="doctor-slide">
                <img
                  src={doctor.image}
                  alt={doctor.name}
                  className="doctor-img"
                />
                <p className="doctor-name">{doctor.name}</p>
                <p className="doctor-designation">{doctor.designation}</p>
              </div>
            ))}
          </Slider>
          <div className="view-speakers-link">
            <Link to="/speakers" onClick={() => window.scrollTo(0, 0)}>
              View All Speakers
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeScreen;
